import gql from 'graphql-tag';
export const KinderConnectCaptureChildSettingFields = gql `
    fragment KinderConnectCaptureChildSettingFields on KinderConnectCaptureChild {
        id
        captureRequired
        child {
            id
            name {
                fullName
            }
            group {
                id
                title
            }
        }
    }
`;
